import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {checkToken} from "../component/utils/TokenUtils";

const useAuthToken = () => {
    const navigate = useNavigate();
    const [token, setToken] = useState(() => localStorage.getItem("token"));

    useEffect(() => {
        const validateToken = () => {
            const newToken = localStorage.getItem("token");
            setToken(newToken);

            if (checkToken(newToken)) {
                localStorage.removeItem("token");
                navigate("/");
            }
        };

        // Проверяем токен при первом рендере
        validateToken();

        // Добавляем слушатель событий изменения `localStorage`
        window.addEventListener("storage", validateToken);
        return () => window.removeEventListener("storage", validateToken);
    }, [navigate]);

    return token;
};

export default useAuthToken;
